import React, {
  useState,
  Fragment,
  useCallback,
  useEffect,
  useContext,
} from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { Dialog, Button, Input, Password, Radio, Toast, Icon } from "@app/components";
import { AuthContext } from "@app/providers";
import {
  MonthList,
  yearsList,
  emailPattern,
  gradesList,
  stateList,
  passwordPattern,
  childPlayOptions,
  chatOptions,
  perferneceOptions,
  subjectOptions,
  subscriptionOptions,
  getArrayData,
  getValuesOnly,
  capitalize,
} from "@app/utils";
import {
  FormFlexWrapper,
  DropdownWrapper,
  Error,
  SelectCustomStyles,
  FlexWrapper,
  CommonLabel,
  EmptyContainer,
  DefaultMessage,
} from "@app/components/commonStyles";
import { updateUser, DataService, getAddress, showStudentPassword, resetStudentPassword, generateStudentPassword } from "@app/services";
import {
  ButtonContainer,
  DialogFooter,
  TabContainer,
  TabContent,
  TabItem,
  TabsList,
  TabContentFormWrapper,
  SubBox,
} from "./editChild-component";
import { useLocation } from "@app/utils";

type Props = {
  onClose: (e: any) => void;
  childData: any;
  setUserDetails: (e: any) => void;
};
const tabsList: any[] = ["Child Details", "Password"];
// const tabsList: any[] = ["Child Details"];

export default function EditChild({
  onClose,
  childData,
  setUserDetails,
}: Props) {
  const {
    register,
    errors,
    control,
    getValues,
    trigger,
    watch,
    handleSubmit,
    setValue,
    clearErrors,
  }: any = useForm({
    mode: "onBlur",
  });
  const [modifiedList, setModifiedList] = useState([
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ])

  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [active, setActive] = useState<any>(tabsList[0]);
  const [buttonText, setButtonText] = useState<string>("Save");
  const [showToast, setShowToast] = useState(false);
  const [zipError, setZipError] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const { navigate } = useLocation();
  const [childYear, setChildYear] = useState<any>()
  const Year = new Date().getFullYear()
  const [childMonth, SetChildMonth] = useState<any>([])
  const userToken = userInfo && userInfo.sessionToken;
  const [spinner, setSpinner] = useState(false);
  const [studentPassword, setStudentPassword] = useState<any>({
    password: "",
  });
  const [passwordChange, setPasswordChange] = useState<boolean>(false);
  const base64 = require('base-64');

  useEffect(() => {
    const Month = new Date().getMonth() + 1;
    modifiedList.map((month: any) => {
      if (month.value <= Month) {
        childMonth.push(month)
      }
    })
    // } else {
    //   childMonth.push(modifiedList)
    // }

  }, [])

  const userDetails = childData;
  const assignValuesToForm = useCallback(() => {
    Object.keys(getValues()).map((key: string) => {
      switch (key) {
        case "birthMonth":
          const getMonthObject = MonthList.find(
            (month) => month.value === userDetails[key]
          );
          return setValue(key, getMonthObject);
        case "state":
          const stateObj = stateList.find(
            (state) => state.value === userDetails[key]
          );
          return setValue(key, stateObj);

        case "birthYear":
          return setValue(key, {
            label: userDetails[key],
            value: userDetails[key],
          });
        case "subject":
          const subArray: any[] = userDetails[key].split(",");
          const filteredSubArray = getArrayData(subArray, subjectOptions);
          return setValue(key, filteredSubArray);
        case "userGrade":
          const getGradeObject = gradesList.find(
            (grade) => grade.value === userDetails[key]
          );
          return setValue(key, getGradeObject);
        case "subscriptionPlans":
          return "freetoPlay";
        case "levelPreference":
          return userDetails[key]
            ? setValue(key, userDetails[key])
            : "challenging";
        case "childPlayOption":
          return userDetails[key] ? setValue(key, userDetails[key]) : "all";
        default:
          setValue(key, userDetails[key]);
      }
      return key;
    });
    // eslint-disable-next-line
  }, [getValues, setValue]);

  useEffect(() => {
    assignValuesToForm();
  }, [assignValuesToForm, active]);

  function changeTab(tab: string) {
    setActive(tab);
    if (tab === "Password") {
      setButtonText("Update");
      setSpinner(true)
      showPassword();
    } else {
      setButtonText("Save");
    }
  }

  function showPassword() {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      requestUserId: childData.userId
    });
    showStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          setStudentPassword({
            userId: response.userId,
            password: base64.decode(response.studentPassword),
          });
          setSpinner(false);
        }
        else {
          setToastMessage({
            type: "error",
            message: (response && response.msgCode) ? response.msg : "Failed to get Password",
          });
          setShowToast(true);
          setSpinner(false);
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
      })
  }

  function generatePassword() {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      update: 0
    });
    setSpinner(true)
    generateStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          setSpinner(false);
          setPasswordChange(true)
          setStudentPassword({
            password: base64.decode(response.studentPassword)
          });
          setToastMessage({
            type: "success",
            message: "Student Password updated Successfully",
          });
          setShowToast(true);
        }
        else {
          setToastMessage({
            type: "error",
            message: "Failed to reset Password",
          });
          setShowToast(true);
          setSpinner(false);
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: "Something went wrong",
        });
        setShowToast(true);
      })
  }

  function onPasswordBlur(evt: any) {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
    if (passwordPattern.test(evt.target.value)) {
      clearErrors("newpassword")
    }
  }
  function onCurPasswordBlur(evt: any) {
    if (passwordPattern.test(evt.target.value)) {
      clearErrors("oldPassword")
    }
  }
  function onConfPasswordBlur(data: any) {
    if (data.newpassword === data.confirmPassword) {
      clearErrors("confirmPassword")
    }


  }

  const handleRefresh = () => {
    window.location.reload();
  };

  function onSubmit(data: any) {
    if (zipError) return;
    const params: any = {};
    Object.assign(params, {
      userId: userInfo.userJson.userId,
      userType: childData.userType,
      sessionToken: userInfo.sessionToken,
      requestUserId: childData.userId,
    });
    if (active === "Child Details") {
      if (!childData.schoolAccountReg) {
        const subjectValues: any = data.subject && getValuesOnly(data.subject);
        Object.assign(params, {
          firstName: data.firstName,
          lastName: data.lastName,
          birthMonth: data.birthMonth.value,
          birthYear: data.birthYear.value,
          userGrade: data.userGrade.value,
          city: data.city,
          state: data.state.value,
          zip: data.zip,
          childPlayOption: data.childPlayOption,
          childMayUse: chatOptions[0].id,
          levelPreference: data.levelPreference,
          subject: subjectValues,
          subscriptionPlans: data.subscriptionPlans,
        });
      } else {
        Object.assign(params, {
          firstName: data.firstName,
          lastName: data.lastName,
        });
      }
      setButtonText("Saving...");
    } else {
      Object.assign(params, {
        // oldPassword: data.oldPassword,
        password: studentPassword.password,
        confirmPassword: studentPassword.password,
      });
      setButtonText("Updating...");
    }
    updateUser(params)
      .then((response) => {
        setButtonText(active === "Child Details" ? "Save" : "Update");
        if (response._responseStatus === 1) {
          if (active === "Child Details") {
            const childObjectIndex: any =
              userInfo.userJson.childDetails.findIndex(
                (child: any) => child.userId === response.userJson.userId
              );
            userInfo.userJson.childDetails[childObjectIndex] =
              response.userJson;
            DataService.sendMessage({
              key: "userJson",
              data: userInfo.userJson,
            });
            localStorage.setItem("userData", JSON.stringify(userInfo));
            setUserDetails(userInfo.userJson);
            setUserInfo(userInfo);
            setToastMessage({
              type: "success",
              message: `Child account details updated successfully`,
            });
            setShowToast(true);
            handleRefresh();
            onClose(false);
          } else {
            setToastMessage({
              type: "success",
              message: `Password updated successfully`,
            });
            setShowToast(true);
            handleRefresh();
            onClose(false);
          }
        } else if (response.msgCode === "SSN_002") {
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: 'Current Password does not match',
          });

          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setButtonText(active === "Child Details" ? "Save" : "Update");
          setToastMessage({
            type: "error",
            message: 'Current Password does not match',
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setToastMessage({
          type: "errror",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
      });
  }
  function onZipBlur(data: any) {
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("city", capitalize(res.city));
          clearErrors("city");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("state", selectedState);
          clearErrors("state");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function onChange(data: any) {
    if (data.target.name === "zip") {
      setValue("city", "");
      setValue("state", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }
  const selectedState: any = stateList.find(
    (state) => state.label === userDetails.state
  );

  const onYearChange = (e: any) => {
    setValue("birthYear", e)
    setValue("birthMonth", '')
    setChildYear(e.value)
    if (e) {
      // setDisableMonth(false)
    } else {
      // setDisableMonth(true)
    }
  }

  return (
    <Dialog
      title="Edit Child Account"
      onClose={onClose}
      className="dialog-with-form"
    >
      <form
        className="tab-layout"
        onSubmit={handleSubmit(onSubmit)}
        onChange={onChange}
      >
        <TabContainer>
          <TabsList>
            {tabsList.map((tab, index) => {
              return (
                <TabItem
                  key={index}
                  active={active === tab}
                  onClick={() => {
                    changeTab(tab);
                  }}
                >
                  {tab}
                </TabItem>
              );
            })}
          </TabsList>
          <TabContent>
            <TabContentFormWrapper>
              {active === "Child Details" && (
                <div style={{ height: "50px" }} >
                  <Fragment>
                    <FormFlexWrapper className="mb-0">
                      <div className="child only-child">
                        <Input
                          label="First Name"
                          placeholder="First Name"
                          name="firstName"
                          register={register({
                            required: true,
                            validate: (value: any) => {
                              return value.trim().length > 0;
                            },
                          })}
                          error={errors.firstName && "Please enter First Name"}
                        />
                      </div>
                    </FormFlexWrapper>
                    <FormFlexWrapper className="mb-0">
                      <div className="child only-child">
                        <Input
                          label="Last Name"
                          placeholder="Last Name"
                          name="lastName"
                          register={register({
                            required: true,
                            validate: (value: any) => {
                              return value.trim().length > 0;
                            },
                          })}
                          error={errors.lastName && "Please enter Last Name"}
                        />
                      </div>
                    </FormFlexWrapper>
                    {!userDetails.schoolAccountReg && (
                      <Fragment>
                        <FormFlexWrapper className=" mb-0">
                          <div className="child only-child">
                            <DropdownWrapper>
                              <CommonLabel>Birth Year</CommonLabel>
                              <Controller
                                // as={Select}
                                value="value"
                                name="birthYear"
                                options={yearsList}
                                placeholder="Birth Year"
                                render={({ onChange, value }: any) => (
                                  <Select
                                    options={yearsList}
                                    onChange={onYearChange}
                                    styles={SelectCustomStyles}
                                    selected={value}
                                    placeholder="Birth Year"
                                    menuPosition={"fixed"}
                                    value={value}
                                  />
                                )}
                                control={control}
                                rules={{ required: true }}
                                // styles={SelectCustomStyles}
                                defaultValue={''}
                              />
                              {errors.birthYear && (
                                <Error>Please select Birth Year</Error>
                              )}
                            </DropdownWrapper>
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className=" mb-0">
                          <div className="child only-child">
                            <DropdownWrapper>
                              <CommonLabel>Birth Month</CommonLabel>
                              <Controller
                                as={<Select isSearchable={false} />}
                                value="value"
                                name="birthMonth"
                                searchable={false}
                                // options={MonthList}
                                options={childYear === Year ? childMonth : MonthList}
                                placeholder="Birth Month"
                                control={control}
                                rules={{ required: true }}
                                styles={SelectCustomStyles}
                                defaultValue={""}
                              />
                              {errors.birthMonth && (
                                <Error>Please select Birth Month</Error>
                              )}
                            </DropdownWrapper>
                          </div>
                        </FormFlexWrapper>

                      </Fragment>
                    )}
                    {userDetails.schoolAccountReg && (
                      <>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <Input
                              label="School Name"
                              placeholder="School Name "
                              name="schoolName"
                              disable={true}
                            />
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <Input
                              label="City"
                              placeholder="City"
                              name="schoolCity"
                              disable={true}
                            />
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <Input
                              label="Zip Code"
                              placeholder="Zip Code"
                              name="schoolZip"
                              disable={true}
                            />
                          </div>
                        </FormFlexWrapper>
                      </>
                    )}
                    <FormFlexWrapper className="mb-0">
                      <div className="child only-child">
                        <Input
                          type="email"
                          label="Child’s Username"
                          placeholder="Child’s Username"
                          name="email"
                          disable={true}
                          register={register({
                            required: true,
                          })}
                          error={
                            (errors.email &&
                              errors.email.type === "required" &&
                              "Please enter Email Address")
                          }
                        />
                      </div>
                    </FormFlexWrapper>

                    {!userDetails.schoolAccountReg && (
                      <Fragment>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <CommonLabel>Grade</CommonLabel>
                            <DropdownWrapper>
                              <Controller
                                as={Select}
                                value="value"
                                name="userGrade"
                                options={gradesList}
                                placeholder="Grade"
                                control={control}
                                rules={{ required: true }}
                                styles={SelectCustomStyles}
                                defaultValue={""}
                              />
                              {errors.userGrade && (
                                <Error>Please select Grade</Error>
                              )}
                            </DropdownWrapper>
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <Input
                              type="number"
                              label="Zip Code"
                              placeholder="Zip Code"
                              name="zip"
                              register={register({
                                required: true,
                                validate: (value: any) => {
                                  return value.trim().length > 0;
                                },
                              })}
                              maxLength={5}
                              onBlur={onZipBlur}
                              error={
                                (errors.zip && "Please enter Zip Code") ||
                                (!errors.zip &&
                                  zipError &&
                                  "Please enter valid Zip Code")
                              }
                            />
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <Input
                              label="City"
                              placeholder="City"
                              name="city"
                              register={register({
                                required: true,
                                validate: (value: any) => {
                                  return value.trim().length > 0;
                                },
                              })}
                              error={errors.city && "Please enter City"}
                            />
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <CommonLabel>State</CommonLabel>
                            <DropdownWrapper>
                              <Controller
                                as={Select}
                                value="value"
                                name="state"
                                options={stateList}
                                placeholder="State"
                                control={control}
                                rules={{ required: true }}
                                styles={SelectCustomStyles}
                                defaultValue={selectedState}
                              />
                              {errors.state && <Error>Please select State</Error>}
                            </DropdownWrapper>
                          </div>
                        </FormFlexWrapper>

                        <FormFlexWrapper>
                          <div className="child only-child">
                            <CommonLabel>Who can my child play with?</CommonLabel>
                            {childPlayOptions.map((each: any) => (
                              <Radio
                                className="radio"
                                name="childPlayOption"
                                value={each.id}
                                key={each.id}
                                checked={true}
                                register={register({
                                  required: true,
                                })}
                                id={"play_" + each.id}
                                label={each.label}
                              />
                            ))}
                            {errors.childPlayOption && (
                              <Error>Please select Child Play Option</Error>
                            )}
                          </div>
                        </FormFlexWrapper>
                        {/* <FormFlexWrapper>
                        <div className="child only-child">
                          <CommonLabel>My child may use</CommonLabel>
                          <FlexWrapper>
                            {chatOptions.map((each: any) => (
                              <Radio
                                className="radio mr-3"
                                name="childMayUse"
                                value={each.id}
                                key={each.id}
                                checked={true}
                                register={register({
                                  required: true,
                                })}
                                id={"chat_" + each.id}
                                label={each.label}
                              />
                            ))}
                          </FlexWrapper>
                          {errors.childMayUse && (
                            <Error>Please select My Child may use</Error>
                          )}
                        </div>
                      </FormFlexWrapper> */}
                        <FormFlexWrapper>
                          <div className="child only-child">
                            <CommonLabel>Level Preference</CommonLabel>
                            <FlexWrapper className="wrap-items">
                              {perferneceOptions.map((each: any) => (
                                <Radio
                                  className="radio mr-3"
                                  name="levelPreference"
                                  value={each.id}
                                  key={each.id}
                                  checked={true}
                                  register={register({
                                    required: true,
                                  })}
                                  id={"level_" + each.id}
                                  label={each.label}
                                />
                              ))}
                            </FlexWrapper>
                            {errors.levelPreference && (
                              <Error>Please select Level Preference</Error>
                            )}
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper className="mb-0">
                          <div className="child only-child">
                            <DropdownWrapper>
                              <CommonLabel>
                                Subjects I'd like my child to explore
                              </CommonLabel>
                              <Controller
                                as={Select}
                                value="value"
                                name="subject"
                                options={subjectOptions}
                                placeholder="Select Subjects"
                                control={control}
                                styles={SelectCustomStyles}
                                defaultValue=""
                                rules={{ required: true }}
                                isMulti={true}
                                menuPosition={"fixed"}
                                closeMenuOnSelect={false}
                              />
                              {errors.subject && (
                                <Error>Please select atleast one Subject</Error>
                              )}
                            </DropdownWrapper>
                          </div>
                        </FormFlexWrapper>
                        <FormFlexWrapper>
                          <div className="child only-child">
                            <CommonLabel>Subscription Plan</CommonLabel>
                            <SubBox>
                              <FlexWrapper>
                                {subscriptionOptions.map((each: any) => (
                                  <Radio
                                    className="radio"
                                    name="subscriptionPlans"
                                    value={each.id}
                                    key={each.id}
                                    checked={true}
                                    register={register({
                                      required: true,
                                    })}
                                    id={"plan_" + each.id}
                                    label={each.label}
                                  />
                                ))}
                              </FlexWrapper>
                            </SubBox>
                          </div>
                        </FormFlexWrapper>
                      </Fragment>
                    )}
                  </Fragment>
                </div>
              )}
              {active === "Password" && (
                <Fragment>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Password
                        label="Current Password"
                        hideIcon={true}
                        defaultPasswordvisiblility={false}
                        placeholder="Current Password"
                        value={studentPassword.password}
                        disable={false}
                      />
                    </div>

                  </FormFlexWrapper>
                  <p className="anchor-tag" onClick={() => generatePassword()}>Generate Password</p>
                  {spinner &&
                    <EmptyContainer>
                      <Icon name="loader" />
                      <DefaultMessage>Loading, please wait...</DefaultMessage>
                    </EmptyContainer>
                  }
                  {/* <FormFlexWrapper className="mb-0">
                    <div className="child only-child">

                      <Password
                        label="New Password"
                        placeholder="New Password"
                        name="newpassword"
                        showInfo={false}
                        showInstructions={true}
                        register={register({
                          required: true,
                          pattern: passwordPattern,
                        })}
                        onChange={onPasswordBlur}
                        error={
                          (errors.newpassword &&
                            errors.newpassword.type === "required" &&
                            "Please enter New Password") ||
                          (errors.newpassword &&
                            errors.newpassword.type === "pattern" &&
                            "Please enter a Strong Password")
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Password
                        label=" Confirm Password"
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        // onChange={onConfPasswordBlur}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return value === watch("newpassword");
                          },
                        })}
                        error={
                          (errors.confirmPassword &&
                            errors.confirmPassword.type === "required" &&
                            "Please confirm Password") ||
                          (errors.confirmPassword &&
                            errors.confirmPassword.type === "validate" &&
                            "Passwords did not match")
                        }
                      />
                    </div>
                  </FormFlexWrapper> */}
                </Fragment>
              )}
            </TabContentFormWrapper>
          </TabContent>
        </TabContainer>
        <DialogFooter className="alt-padding">
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>

          {<ButtonContainer
            disabled={
              buttonText === "Saving..." || buttonText === "Updating..."
            }
          >
            <Button variant="newsecondary" type="submit" disabled={(active === "Password") ? !passwordChange : false}>
              {buttonText}
            </Button>
          </ButtonContainer>}
        </DialogFooter>
      </form >
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        title="Update Child"
        onClose={() => setShowToast(false)}
      />
    </Dialog >
  );
}
